import React, { useEffect, useState } from "react";
import Button from "../../../components/Button";
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import ConfirmBoxModal from "../../../components/ConfirmBoxModal";
import useAddVendor from "./hooks/useAddVendor";
import useUpdateVendor from "./hooks/useUpdateVendor";
import useVendorType from "./hooks/useVendorType";
import useGetVendorRecurrency from "./hooks/useGetVendorRecurrency";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  addStateVendor,
  editStateVendor,
  setFilterTextVendor,
  rowEditIdStateVendor,
  // pciFileAttachment,
  // pciFileAttachmentForDelete,
  // sqFileAttachment,
  // soc2FileAttachment,
  // miscFileAttachment,
  // miscFileAttachmentForDelete,
  // soc2FileAttachmentForDelete,
  // sqFileAttachmentForDelete,
  // complianceStatus,
  // pciDisplay,
  // secDisplay,
  // miscDisplay,
  // socDisplay,
} from "./atoms/atoms";
import TextInputLabelHookForm from "../../../components/TextInputLabelHookForm";
import { useForm, Controller, FormProvider } from "react-hook-form";
import SelectHookFormSingle from "../../../components/SelectHookFormSingle";
import CheckBoxHookForm_2 from "../../../components/CheckBoxHookForm_2";
import VendorAddress from "./forms/VendorAddress";
import CancelButton from "../../../components/CancelButton";
import { toast } from "../../../components/toastNotification";
import TextInputHookFormDisabled from "../../../components/TextInputHookFormDisabled";
import TextInputLabelPhone from "../../../components/TextInputLabelPhone";
import { EyeSlashIcon, EyeIcon } from "@heroicons/react/24/solid";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";
import { FIELDPERMISSIONS, PERMISSIONS } from "../../PermissionsConstants";
import Password from "../../../components/Password";
import useVendorDuplicateChecker from "./hooks/useVendorDuplicateChecker";
// import VendorSecurityForm from "./forms/VendorSecurityForm";

const VendorForm = () => {
  //Hooks
  const AddVendor = useAddVendor();
  const UpdateVendor = useUpdateVendor();
  const { mutateAsync: CheckVendorDuplicate } = useVendorDuplicateChecker();
  //Recoils Call
  const [actionAddState, setActionAddState] = useRecoilState(addStateVendor);
  const [actionEditState, setEditState] = useRecoilState(editStateVendor);
  const [rowForEdit] = useRecoilState(rowEditIdStateVendor);
  const [, setFilterText] = useRecoilState(setFilterTextVendor);
  const [openModal, setOpenModal] = useState(false);
  const [newData, setNewData] = useState([]);
  //for email validation use
  const [validEmail, setValidEmail] = useState(true);
  const [validTonerEmail, setValidTonerEmail] = useState(true);
  const emailRe =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  // vendor user and password permission
  const userPermissions = useRecoilValue(permissionsSelector);
  const viewUserPermission = FIELDPERMISSIONS.fieldpermission_vendor_user;
  const viewPassPermission = FIELDPERMISSIONS.fieldpermission_vendor_sensitive;
  const approverPermission =
    FIELDPERMISSIONS.fieldpermission_vendorinvoice_approver;

  //Vendor Security Permission
  // const vendorSecurityAdd = PERMISSIONS.permission_vendor_vendorSecurity_add;
  // const vendorSecurityEdit = PERMISSIONS.permission_vendor_vendorSecurity_edit;

  //Vendor Security
  //For PCI
  // const [pciFile, setPciFile] = useRecoilState(pciFileAttachment);
  // const [pciFileForDelete] = useRecoilState(pciFileAttachmentForDelete);

  //For Security Questionnaire
  // const [questionnaireFile, setQuestionnaireFile] =
  //   useRecoilState(sqFileAttachment);
  // const [questionnaireFileForDelete] = useRecoilState(
  //   sqFileAttachmentForDelete
  // );

  //For SOC 2 Report
  // const [socFile, setSocFile] = useRecoilState(soc2FileAttachment);
  // const [socFileForDelete] = useRecoilState(soc2FileAttachmentForDelete);

  //For Miscellaneous
  // const [miscellaneousFile, setMiscellaneousFile] =
  //   useRecoilState(miscFileAttachment);
  // const [miscellaneousFileForDelete] = useRecoilState(
  //   miscFileAttachmentForDelete
  // );
  const useFormMethods = useForm(
    actionEditState ? { defaultValues: { ...rowForEdit } } : ""
  );

  // const [pciaocDisplay] = useRecoilState(pciDisplay);
  // const [secqDisplay] = useRecoilState(secDisplay);
  // const [miscellaneousDisplay] = useRecoilState(miscDisplay);
  // const [soc2ReportDisplay] = useRecoilState(socDisplay);

  const {
    formState: { errors, isDirty },
    register,
    control,
    handleSubmit,
    setValue,
    watch,
  } = useFormMethods;
  //dropdown list
  const { data: vendorType } = useVendorType();
  const vendorTypeOpts = vendorType?.map((x) => {
    return {
      label: x.vendorTypeName,
      value: x.id,
    };
  });

  const { data: vendorRecurrency } = useGetVendorRecurrency();
  const vendorRecurrencyOpts = vendorRecurrency?.map((x) => {
    return {
      label: x.recurrencyName,
      value: x.recurrencyId,
    };
  });

  useEffect(() => {
    if (actionEditState && rowForEdit) {
      if (rowForEdit?.isInActive === "True") {
        setValue("isInActive", 1);
      } else if (rowForEdit?.isInActive === "False") {
        setValue("isInActive", 0);
      }
    }
  }, [rowForEdit, actionEditState]);

  // const [status, setStatus] = useRecoilState(complianceStatus);

  // const pciaocAttachments = pciFile?.filter((x) => x !== null);
  // const soc2ReportAttachments = socFile?.filter((x) => x !== null);
  // const securityQuestionnaireAttachments = questionnaireFile?.filter(
  //   (x) => x !== null
  // );
  // const miscellaneousAttachments = miscellaneousFile?.filter((x) => x !== null);

  //form onSubmit
  const onSubmit = (data) => {
    // let hasMissingFiles = false;

    // const vendorSecurityAttachments = [
    //   {
    //     pciaoc: pciaocAttachments,
    //   },
    //   {
    //     soc2Report: soc2ReportAttachments,
    //   },
    //   {
    //     securityQuestionnaire: securityQuestionnaireAttachments,
    //   },
    //   {
    //     miscellaneous: miscellaneousAttachments,
    //   },
    // ];

    // const filteredAttachment = vendorSecurityAttachments?.filter(
    //   (x) => Object.values(x)[0]?.length > 0
    // );

    // const vendorSecurityValidations = [
    //   {
    //     isChecked: data.pciaoc,
    //     label: "PCI AOC!",
    //     attachmentDisplay: pciaocDisplay,
    //   },
    //   {
    //     isChecked: data.soc2Report,
    //     label: "SOC 2 Report!",
    //     attachmentDisplay: soc2ReportDisplay,
    //   },
    //   {
    //     isChecked: data.securityQuestionnaire,
    //     label: "Security Questionnaire!",
    //     attachmentDisplay: secqDisplay,
    //   },
    //   {
    //     isChecked: data.miscellaneous,
    //     label: "Miscellaneous!",
    //     attachmentDisplay: miscellaneousDisplay,
    //   },
    // ];

    // vendorSecurityValidations.forEach(
    //   ({ isChecked, label, attachmentDisplay }) => {
    //     if (
    //       userPermissions.includes(vendorSecurityEdit) &&
    //       actionEditState &&
    //       isChecked &&
    //       attachmentDisplay?.length === 0
    //     ) {
    //       toast.fire("Failed", `Attachment required for ${label}`, "warning");
    //       hasMissingFiles = true;
    //     } else if (
    //       userPermissions.includes(vendorSecurityAdd) &&
    //       actionAddState &&
    //       isChecked &&
    //       attachmentDisplay?.length === 0
    //     ) {
    //       toast.fire("Failed", `Attachment required for ${label}`, "warning");
    //       hasMissingFiles = true;
    //     }
    //   }
    // );

    CheckVendorDuplicate(
      {
        ...data,
      },
      {
        onSuccess: (res) => {
          if (res === "Duplicate") {
            toast.fire("Failed", "Vendor Code already exist", "error");
          } else {
            if (validEmail && validTonerEmail) {
              // if (
              //   (actionEditState && hasMissingFiles === false && isDirty) ||
              //   (actionEditState &&
              //     hasMissingFiles === false &&
              //     filteredAttachment?.length > 0)
              // ) {
              if (actionEditState && isDirty) {
                setOpenModal(true);
                setNewData({
                  ...data,
                  // pciaocAttachment: pciaocAttachments,
                  // soc2ReportAttachment: soc2ReportAttachments,
                  // securityQuestionnaireAttachment:
                  //   securityQuestionnaireAttachments,
                  // miscellaneousAttachment: miscellaneousAttachments,
                  // vendorSecurityComplianceStatus: status
                  //   ? status
                  //   : rowForEdit.vendorSecurityComplianceStatus,
                  // pciaocFileForDelete:
                  //   pciFileForDelete?.length > 0
                  //     ? pciFileForDelete[0]?.pciaocFilename
                  //     : "",
                  // securityQuestionnaireFileForDelete:
                  //   questionnaireFileForDelete?.length > 0
                  //     ? questionnaireFileForDelete[0]
                  //         ?.securityQuestionnaireFilename
                  //     : "",
                  // soc2ReportFileForDelete:
                  //   socFileForDelete?.length > 0
                  //     ? socFileForDelete[0]?.soc2ReportFilename
                  //     : "",
                  // miscellaneousFileForDelete:
                  //   miscellaneousFileForDelete?.length > 0
                  //     ? miscellaneousFileForDelete[0]?.miscellaneousFilename
                  //     : "",
                });
                setEditState(true);
                // setPciFile([]);
                // setQuestionnaireFile([]);
                // setMiscellaneousFile([]);
                // setSocFile([]);
                // setStatus("");
                // } else if (actionAddState && hasMissingFiles === false) {
              } else if (actionAddState) {
                setOpenModal(true);
                setNewData({
                  ...data,
                  // pciaocAttachment: pciaocAttachments,
                  // soc2ReportAttachment: soc2ReportAttachments,
                  // securityQuestionnaireAttachment:
                  //   securityQuestionnaireAttachments,
                  // miscellaneousAttachment: miscellaneousAttachments,
                  // vendorSecurityComplianceStatus: status
                  //   ? status
                  //   : rowForEdit.vendorSecurityComplianceStatus,
                });
                setActionAddState(true);
                // setPciFile([]);
                // setQuestionnaireFile([]);
                // setMiscellaneousFile([]);
                // setSocFile([]);
                // setStatus("");
              } else if (
                !isDirty
                // && hasMissingFiles === false &&
                // filteredAttachment?.length === 0
              ) {
                toast.fire(
                  "Saving Failed",
                  "No changes have been made.",
                  "warning"
                );
              }
            }
          }
        },
      }
    );
  };

  //save changes
  const handleSave = () => {
    var vendorRecurrencyIdValue =
      newData.vendorType === 9 ? newData.vendorRecurrencyId : null;
    if (actionAddState) {
      AddVendor({ ...newData, vendorRecurrencyId: vendorRecurrencyIdValue });
      setOpenModal(false);
    } else {
      UpdateVendor({
        ...newData,
        vendorRecurrencyId: vendorRecurrencyIdValue,
      });
      setOpenModal(false);
    }
  };
  // end of saving changes

  //cancel
  const handleCancel = () => {
    // setPciFile([]);
    // setSocFile([]);
    // setQuestionnaireFile([]);
    // setMiscellaneousFile([]);
    setActionAddState(false);
    setEditState(false);
    setFilterText("");
    // setStatus("");
    useFormMethods.reset();
    useFormMethods.clearErrors();
  };

  const [checkType, setCheckType] = useState("password");
  const handleShowHide = (e) => {
    const type = e.target.value;

    if (type === "password") {
      setCheckType("text");
      //setText("Hide");
    } else {
      setCheckType("password");
      //setText("Show");
    }
  };

  const isApprover = userPermissions.includes(approverPermission);
  return (
    <div>
      <div className="p-3 space-y-2 border-l-2 border-primary box-shadow mt-2">
        <FormProvider {...useFormMethods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="flex flex-row  justify-between items-center text-quinary font-bold font-sans text-lg">
              <div className="ml-2 font-bold text-primary text-md">
                {actionAddState ? "Add Vendor" : "Edit Vendor"}
              </div>
              <div className="flex justify-between gap-2 mr-2">
                <Button
                  className={`flex items-center shadow-md text-xs font-semibold text-white justify-center gap-x-1 rounded-xl bg-senary hover:bg-senary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70`}
                  type="submit"
                >
                  <CheckCircleIcon className="h-4 w-4" />
                  <div>Save</div>
                </Button>
                <CancelButton
                  onClick={() => {
                    handleCancel();
                  }}
                />
              </div>
            </div>
          </form>
          <div className="mx-2 border-b-2 border-secondary"></div>
          <div className="text-xs text-secondary italic font-normal mt-2 ml-2">
            <b> Note:</b> All fields with * are required to fill.
          </div>
          <div className="m-2 bg-white box-shadow rounded-lg h-full">
            <div className="text-quinary font-bold font-sans py-2 px-4">
              Vendor Details
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 mx-4 mr-5 pb-2 gap-12">
              <div className="space-y-1 mr-6">
                <Controller
                  control={control}
                  name="name"
                  rules={{ required: true }}
                  render={() => (
                    <TextInputLabelHookForm
                      name="name"
                      label="Vendor Name"
                      type="text"
                      placeholder="Vendor Name"
                      register={register("name", {})}
                      maxLength={50}
                      required={true}
                      className={
                        errors.name && "border-2 border-red-500 col-span-2 "
                      }
                    />
                  )}
                />
                <Controller
                  control={control}
                  name="vendorCode"
                  rules={{ required: false }}
                  render={() => (
                    <TextInputLabelHookForm
                      name="vendorCode"
                      label="Vendor Code"
                      type="text"
                      placeholder="Vendor Code"
                      register={register("vendorCode", {})}
                      className={
                        errors.vendorCode &&
                        "border-2 border-red-500 col-span-2"
                      }
                      secondDiv="grid grid-cols-3 w-full items-center gap-2"
                    />
                  )}
                />
                <Controller
                  control={control}
                  rules={{ required: true }}
                  name="vendorType"
                  render={({ field }) => (
                    <SelectHookFormSingle
                      field={field}
                      onChange={(e) => {
                        field.onChange(e ? e.value : null);
                        if (e.value !== 8) {
                          setValue("tonerRequestPhone", "");
                          setValue("tonerRequestEmail", "");
                        }
                      }}
                      value={field.value}
                      options={vendorTypeOpts}
                      label="Type"
                      required={true}
                      className={
                        errors.vendorType &&
                        "border-2 border-red-500 col-span-2 "
                      }
                    />
                  )}
                />
                <TextInputLabelHookForm
                  name="email"
                  label="Email"
                  type="text"
                  placeholder="Email"
                  register={register("email", {})}
                  onChange={(e) => {
                    if (emailRe.test(e.target.value) || e.target.value === "") {
                      setValidEmail(true);
                    } else {
                      setValidEmail(false);
                    }
                  }}
                  className={
                    validEmail
                      ? "border border-gray-300 col-span-2"
                      : "border-2 border-red-500 col-span-2 "
                  }
                />
                <span
                  className="text-xs text-secondary font-normal mb-2"
                  hidden={validEmail}
                >
                  invalid email format.
                </span>

                <TextInputLabelHookForm
                  name="website"
                  label="Website"
                  type="text"
                  placeholder="Website"
                  register={register("website", {})}
                />
                <TextInputLabelHookForm
                  name="accountNumber"
                  label="Account Number"
                  type="text"
                  placeholder="Account Number"
                  register={register("accountNumber", {})}
                  maxLength={15}
                />
              </div>
              <div className="space-y-1">
                <Controller
                  control={control}
                  name="contact"
                  rules={{ required: true }}
                  render={() => (
                    <TextInputLabelHookForm
                      name="contact"
                      label="Contact"
                      type="text"
                      placeholder="Contact"
                      register={register("contact", {})}
                      maxLength={30}
                      required={true}
                      className={
                        errors.contact && "border-2 border-red-500 col-span-2 "
                      }
                    />
                  )}
                />
                <TextInputLabelPhone
                  name="phone"
                  label="Phone"
                  pattern="(\(\d{3}\)) \d{3}[-]\d{4}"
                  title="Format: (000) 000-0000"
                  required={true}
                  maxLength={11}
                  className={
                    errors.phone &&
                    errors.phone.message &&
                    "border-2 border-red-500 col-span-2 "
                  }
                  register={register("phone", {
                    required: {
                      value: true,
                      message: "Required Field",
                    },
                  })}
                  onChange={(e) => {
                    var x = e.target.value
                      .replace(/\D/g, "")
                      .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                    e.target.value = !x[2]
                      ? x[1]
                      : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
                  }}
                />
                {userPermissions.includes(viewUserPermission) && (
                  <TextInputLabelHookForm
                    name="vendorUser"
                    label="User"
                    type="text"
                    placeholder="User"
                    register={register("vendorUser", {})}
                    className={
                      errors.vendorUser && "border-2 border-red-500 col-span-2 "
                    }
                  />
                )}
                {userPermissions.includes(viewPassPermission) && (
                  <div className="grid grid-cols-1 md:grid-cols-3 w-full items-center gap-1">
                    <label className="flex text-left expandedLabel fontExpand">
                      Password:
                    </label>
                    <div className="col-span-2 flex flex-row  gap-2">
                      <div className="flex flex-row">
                        {" "}
                        <div className="flex items-center">
                          <div className="relative flex items-center w-full">
                            <Password
                              name="vendorPassword"
                              // label="Password"
                              type={checkType}
                              placeholder="Password"
                              register={register("vendorPassword", {})}
                              required={true}
                              className={
                                errors.vendorPassword &&
                                "border-2 border-red-500 col-span-2 "
                              }
                            />
                          </div>
                        </div>
                        <div>
                          <button
                            className="px-2 h-5 w-5 "
                            onClick={(e) => handleShowHide(e)}
                            value={checkType}
                          ></button>
                          {checkType === "text" ? (
                            <EyeSlashIcon className="fill-primary cursor-pointer stroke-primary h-4 w-4 -mt-5 ml-1" />
                          ) : (
                            <EyeIcon className="fill-primary cursor-pointer stroke-primary h-4 w-4 -mt-5 ml-1" />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {/* {actionEditState && ( */}
                <TextInputHookFormDisabled
                  name="paymentTerms"
                  label="Payment Terms"
                  type="text"
                  register={register("paymentTerms", {})}
                  disabled={true}
                />
                {/* )} */}
                {watch("vendorType") === 9 && (
                  <Controller
                    control={control}
                    rules={{ required: true }}
                    name="vendorRecurrencyId"
                    render={({ field }) => (
                      <SelectHookFormSingle
                        field={field}
                        onChange={(e) => {
                          field.onChange(e ? e.value : null);
                        }}
                        value={field.value}
                        options={vendorRecurrencyOpts}
                        label="Recurrency of the Service"
                        required={true}
                        className={
                          errors.vendorRecurrencyId &&
                          "border-2 border-red-500 col-span-2 "
                        }
                      />
                    )}
                  />
                )}

                {watch("vendorType") === 8 && (
                  <>
                    <TextInputLabelHookForm
                      name="tonerRequestEmail"
                      label="Toner Request Email"
                      type="text"
                      placeholder="TonerRequestEmail"
                      register={register("tonerRequestEmail", {})}
                      onChange={(e) => {
                        if (
                          emailRe.test(e.target.value) ||
                          e.target.value === ""
                        ) {
                          setValidTonerEmail(true);
                        } else {
                          setValidTonerEmail(false);
                        }
                      }}
                      className={
                        validTonerEmail
                          ? "border border-gray-300 col-span-2"
                          : "border-2 border-red-500 col-span-2 "
                      }
                    />
                    <span
                      className="text-xs text-secondary font-normal mb-2"
                      hidden={validTonerEmail}
                    >
                      invalid email format.
                    </span>
                    <TextInputLabelPhone
                      name="tonerRequestPhone"
                      label="Toner Request Phone"
                      pattern="(\(\d{3}\)) \d{3}[-]\d{4}"
                      title="Format: (000) 000-0000"
                      required={true}
                      maxLength={11}
                      className={
                        errors.tonerRequestPhone &&
                        "border-2 border-red-500 col-span-2 "
                      }
                      register={register("tonerRequestPhone", {
                        required: {
                          value: true,
                          message: "Required Field",
                        },
                      })}
                      onChange={(e) => {
                        var x = e.target.value
                          .replace(/\D/g, "")
                          .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                        e.target.value = !x[2]
                          ? x[1]
                          : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
                      }}
                    />
                  </>
                )}

                <div className="w-full ">
                  <div className="">
                    <CheckBoxHookForm_2
                      name="isInActive"
                      label="Inactive Account:"
                      type="checkbox"
                      register={register}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <VendorAddress
              isUtilitiesType={rowForEdit.vendorType === 3}
              isApprover={isApprover}
              isEdit={actionEditState}
            />
          </div>
          {/* <div>
            {((userPermissions.includes(vendorSecurityAdd) && actionAddState) ||
              (userPermissions.includes(vendorSecurityEdit) &&
                actionEditState)) && (
              <VendorSecurityForm
                rowForEdit={rowForEdit}
                actionAddState={actionAddState}
              />
            )}
          </div> */}
          {!actionAddState && (
            <div className="m-2 bg-white box-shadow rounded-lg h-full">
              <div className="text-quinary font-bold font-sans py-2 px-4">
                System Information
              </div>
              <div className="grid grid-cols-1 md:grid-cols-1 mx-4 mr-5 pb-2 gap-12">
                <div className="space-y-1 mr-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 mr-5 pb-2 gap-12">
                    <div className="space-y-1 mr-6">
                      <TextInputHookFormDisabled
                        label="Last Modified By"
                        name="modifiedBy"
                        register={register("modifiedBy", {})}
                      />
                    </div>
                    <div className="space-y-1 mr-6">
                      <TextInputHookFormDisabled
                        label="Last Modified Date"
                        name="modifiedDate"
                        register={register("modifiedDate", {})}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* </form> */}
        </FormProvider>
      </div>
      <div className="w-full ">
        <ConfirmBoxModal
          ModalTitle={actionAddState ? "Add Vendor" : "Update Vendor"}
          qConfirmation={
            actionAddState
              ? "Are you sure you want to add this?"
              : "Are you sure you want to update this?"
          }
          isOpen={openModal}
          onClose={() => setOpenModal(false)}
          onClickFunction={() => {
            handleSave();
          }}
        />
      </div>
    </div>
  );
};

export default VendorForm;
